import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { Alert } from '@material-ui/lab';
import React, { useState } from 'react';
import WindsorApi from '../../api/WindsorApi';
import LoadingButton from '../../common/LoadingButton';
import FileUploadForm from './FileUploadForm';
import FileUtils from './FileUtils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alert: {
      marginBottom: 24
    },
    dialogContent: { 
      width: 400 
    },
    nameTextField: { 
      marginBottom: 24 
    }
  })
);

interface Props {
  familyId: string;
  onClose: (test?: any) => void;
}

const windsorApi = new WindsorApi();

function CreateTestDialog(props: Props) {
  const { familyId, onClose } = props;
  const classes = useStyles({});
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');
  const [showFormErrors, setShowFormErrors] = useState(false);
  const [serverError, setServerError] = useState(null);
  const [createInProgress, setCreateInProgress] = useState(false);

  const onFileChange = (file) => {
    setFile(file);
  };

  const onNameChange = (event) => {
    setName(event.target.value);
  };

  const onCreateTest = async () => {
    setServerError(null);
    if (!name || !file) {
      setShowFormErrors(true);
    } else {
      setCreateInProgress(true);
      const fileBytes = await new FileUtils().readFileBytes(file);

      windsorApi.createTest(familyId, name, fileBytes).then(res => {
        onClose(res);
      }).catch(error => {
        setCreateInProgress(false);
        if (error.status === 400 || error.status === 409) {
          setServerError(error.data.errorMessage);
        } else {
          setServerError('Unknown error occurred, please try your request again...')
        }
      });
    }
  };

  return (<Dialog
    open={true}
    onClose={() => onClose()}
    disableBackdropClick={createInProgress}
    aria-labelledby="new-test-dialog-title"
    aria-describedby="new-test-dialog-description"
  >
    <DialogTitle id="new-test-dialog-title">Create Windsor Test</DialogTitle>
    <DialogContent className={classes.dialogContent}>
      {serverError && <Alert severity="error" className={classes.alert}>
        <Typography>{serverError}</Typography>
      </Alert>}
      <TextField
        fullWidth
        required
        error={showFormErrors && !name}
        helperText={showFormErrors && !name ? 'Name is required' : ''}
        className={classes.nameTextField}
        value={name}
        label="Test Name"
        placeholder="Enter a name for your test"
        onChange={onNameChange}
        InputLabelProps={{
          shrink: true
        }}
      />
      <FileUploadForm file={file} showFormErrors={showFormErrors} onFileChange={onFileChange} />
    </DialogContent>
    <DialogActions>
      <Button disabled={createInProgress} onClick={() => onClose()} color="primary">
        Cancel
      </Button>
      <LoadingButton
        color="primary"
        variant="text"
        loading={createInProgress}
        onClick={onCreateTest}>
        Create
      </LoadingButton>
    </DialogActions>
  </Dialog>
  );
};

export default CreateTestDialog;
